<template>
	<div :style="`height: ${services_box_height}`" :key="`services_box_${gallery_items_active.id}`"
		class="services_box" :class="(is_content_text_short) ? 'short' : ''" id="services">
		<div style="position: relative; height: 0px;opacity: 0;overflow: hidden;">
			<img style="position: absolute;" v-for="(item, idx) in gallery_items" :key="`preload_${idx}`" :src="item.img">
		</div>
		<div v-if="$store.getters.screenWidth > 575" class="desktop_services_gallery">

			<div class="services_gallery_content">
				<div style="position: relative;">
					<div style="position:relative;z-index: 1;width: 100%;height: 100%;">
						<img style="object-fit: contain; width: 100%;" :src="gallery_items_active.img" alt="">
					</div>
					<Transition name="fade-img" mode="in-out">
						<img :key="`services_img_${gallery_items_active.id}`" style="object-fit: contain;top: 0; width: 100%; position:absolute;z-index: 2;" :src="gallery_items_active.img" alt="">
					</Transition>
					<div class="services_gallery_menu">
						<div class="services_gallery_menu_item" :class="{active: gallery_items[0].active}" @click="gallery_items_click_handle(1)">
							<div class="services_gallery_menu_item_img_box">
								<div class="services_gallery_menu_item_img_animation"></div>
								<img src="../assets/img/svg/icon1.svg" alt="">
							</div>
							<div>
								ОКЕАНАРИУМ
							</div>
						</div>
						<div class="services_gallery_menu_item" :class="{active: gallery_items[1].active}" @click="gallery_items_click_handle(2)">
							<div class="services_gallery_menu_item_img_box">
								<div class="services_gallery_menu_item_img_animation"></div>
								<img src="../assets/img/svg/icon2.svg" alt="">
							</div>
							<div>
								ПЕСЧАНЫЙ<br>ПЛЯЖ
							</div>
						</div>
						<div class="services_gallery_menu_item" :class="{active: gallery_items[2].active}"  @click="gallery_items_click_handle(3)">
							<div class="services_gallery_menu_item_img_box">
								<img src="../assets/img/svg/icon3.svg" alt="">
								<div class="services_gallery_menu_item_img_animation"></div>
							</div>
							<div>
								ПОДОГРЕВАЕМЫЙ<br>БАССЕЙН
							</div>
						</div>
						<div class="services_gallery_menu_item" :class="{active: gallery_items[3].active}"  @click="gallery_items_click_handle(4)">
							<div class="services_gallery_menu_item_img_box">
								<img src="../assets/img/svg/icon4.svg" alt="">
								<div class="services_gallery_menu_item_img_animation"></div>
							</div>
							<div>
								SPA | УХОД
							</div>
						</div>
					</div>
					<div style="z-index: 3;width: 100%; height: 30%; position:absolute; top: -2px; background: linear-gradient(180deg, #161616 3.59%, rgba(22, 22, 22, 0.8) 45.77%, rgba(22, 22, 22, 0) 96.3%);"></div>
					<div style="z-index: 3;width: 100%; height: 30%; position:absolute; bottom: -2px; background: linear-gradient(0deg, #161616 3.59%, rgba(22, 22, 22, 0.8) 45.77%, rgba(22, 22, 22, 0) 96.3%);"></div>
				</div>
				<div class="services_content_box">
					<div class="services_content">
						<Transition appear name="fade-text" mode="out-in">
							<div :key="`content_${gallery_items_active.id}`" style="width: 60%; padding: 0.5em;">
								<div class="services_content_subtitle">
									{{gallery_items_active.subtitle}}
								</div>
								<div  class="services_content_title">
									{{gallery_items_active.title}}
								</div>
								<br>
								<div class="services_content_text" v-html="gallery_items_active.text"></div>
							</div>
						</Transition>
						<div :key="`tags_${gallery_items_active.id}`" class="tags_box">
							<b-button :key="idx" v-for="(tag, idx) in gallery_items_active.tags">
								{{tag}}
							</b-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="mobile_services_gallery" ref="mobile_services_gallery"
				:key="`mobile_services_gallery_${gallery_items_active.id}`"
				v-touch:swipe.left="mobile_services_gallery_arrow_left_click_handle"
				v-touch:swipe.right="mobile_services_gallery_arrow_right_click_handle"
		>

			<div class="mobile_services_gallery_content">
				<div class="mobile_services_gallery_box_img">
					<img class="mobile_services_gallery_img" :src="gallery_items_active.img" alt="">
				</div>
				<Transition name="fade-img" mode="in-out">
					<img class="mobile_services_gallery_img"  :key="`services_img_${gallery_items_active.id}`" style="position:absolute; top: 0; z-index: 2;" :src="gallery_items_active.img" alt="">
				</Transition>
				<div style="z-index: 3;width: 100%; height: 30%; position:absolute; top: 0; background: linear-gradient(180deg, #161616 3.59%, rgba(22, 22, 22, 0.8) 45.77%, rgba(22, 22, 22, 0) 96.3%);"></div>
				<div style="z-index: 3;width: 100%; height: 30%; position:absolute; bottom: 0; background: linear-gradient(0deg, #161616 3.59%, rgba(22, 22, 22, 0.8) 45.77%, rgba(22, 22, 22, 0) 96.3%);"></div>
			</div>
			<div class="mobile_services_content_box">
				<div class="mobile_services_content">
					<Transition appear name="fade-text" mode="out-in">
						<div :key="`content_${gallery_items_active.id}`" style="position: relative">
							<div class="mobile_services_content_icon">
								<img :src="gallery_items_active.icon.src" alt="">
							</div>

							<div class="mobile_services_content_title">

								{{gallery_items_active.title}}
								<div class="mobile_services_gallery_arrow_left" @click="mobile_services_gallery_arrow_left_click_handle">
									<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20 40C20 31.2193 12.2537 23.6256 0.999999 20C12.2537 16.3744 20 8.7807 20 -2.22278e-06' stroke='#A6CBD3' style='stroke:#A6CBD3;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>
								</div>
								<div class="mobile_services_gallery_arrow_right" @click="mobile_services_gallery_arrow_right_click_handle">
									<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 40C1 31.2193 8.7463 23.6256 20 20C8.7463 16.3744 1 8.7807 1 -2.22278e-06' stroke='#A6CBD3' style='stroke:#A6CBD3;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>
								</div>
							</div>
							<div class="mobile_services_content_subtitle">
								{{gallery_items_active.subtitle}}
							</div>
							<div :key="`tags_${gallery_items_active.id}`" class="mobile_tags_box">
								<b-button :key="idx" v-for="(tag, idx) in gallery_items_active.tags">
									{{tag}}
								</b-button>
							</div>
							<div class="mobile_services_content_text" v-html="gallery_items_active.text"></div>
						</div>
					</Transition>
				</div>
			</div>
		</div>
		<div v-if="$store.getters.screenWidth <= 575" class="mobile_content_text_btn_box">
			<b-button class="mobile_content_text_btn" @click="content_text_size_toggle">
				{{ (is_content_text_short) ? 'ПОДРОБНЕЕ' : 'СВЕРНУТЬ' }}
			</b-button>
		</div>
		<div v-if="$store.getters.screenWidth <= 575" style="z-index: 5;width: 100%; height: 5em; position:absolute; bottom: 0; background: linear-gradient(0deg, #161616 3.59%, rgba(22, 22, 22, 0.8) 45.77%, rgba(22, 22, 22, 0) 96.3%);"></div>
	</div>
</template>

<script>
// import ServicesGalleryComponent from "@/components/ServicesGalleryComponent.vue"

export default {
	name: "ServicesComponent",
	components: {
		// ServicesGalleryComponent,
	},
	data() {
		return {
			services_box_height: 0 + 'px',
			is_content_text_short: true,
			gallery_items: [
				{
					id:  1,
					active:  true,
					title: "МОРСКИЕ ОБИТАТЕЛИ",
					img: require("../assets/img/nick_alx__photo_Spa_treatments_girl_in_the_center_dark_colors_a_5f8a52fb-b647-42f6-b646-1ad8176ba14d 1.jpg"),
					subtitle: "ПЛАВАНИЕ, ИГРЫ И ОБЩЕНИЕ С МОРСКИМИ КОТИКАМИ, ДЕЛЬФИНАМИ И БЕЛУХАМИ",

					text: `
						Океанариум — визитная карточка Dolphin Planet. Отправьтесь в увлекательное путешествие с
						жителями нашего комплекса, поплавайте с белухой и станьте настоящим тренером дельфинов, а
						после загляните на захватывающий дух «Морская история» — спектакль, посвященный поиску
						гармонии между людьми в мире современных технологий.
						<br>
						Посещение океанариума позволит узнать больше о фауне и разнообразии морского мира, а
						также улучшить свое эмоциональное состояние и избавиться от синдрома хронической усталости.
					`,
					tags: ['Океанариум', 'Дельфины', 'Белые киты', 'Морские котики', 'Шоу морских обитателей', 'Обед в компании морских обитателей', 'Дельфинокоррекция', 'Романтическое свидание', 'Образовательный интерактив с дельфинами',],
					icon: {
						id:  1,
						src: require("../assets/img/svg/icon1.svg"),
						title: "ОКЕАНАРИУМ",
					},
				},
				{
					id:  2,
					active:  false,
					title: "ОСТРОВОК МОРЯ",
					img: require("../assets/img/nick_alx__photo_Spa_treatments_girl_in_the_center_dark_colors_a_5f8a52fb-b647-42f6-b646-1ad8176ba14d 2.jpg"),
					subtitle: "ЛЕТНИЙ ПЕСЧАНЫЙ ПЛЯЖ И ИСКУССТВЕННАЯ ВОЛНА",
					text: `
						Идеальная возможность насладиться теплым песком, приятным бризом и кристально чистой водой.
						Искусственная волна создает ощущение природного морского прибоя, а бар «Волна» дает возможность
						совместить отдых с дегустацией освежающих коктейлей и авторских закусок.
						<br>
						Вечером пляж становится идеальным местом для вечеринки или романтического ужина.
					`,
					tags: ['Активный отдых', 'Фитнес / Йога', 'Катание на сапах', 'Летний бар', 'Гастрономия', 'Детская игровая площадка', 'Кинопоказы', 'Вечеринки', 'Спортивные мероприятия', 'Песочный пляж', 'Искусственная волна', 'Великолепные закаты',],
					icon: {
						id:  2,
						src: require("../assets/img/svg/icon2.svg"),
						title: "ПЕСЧАНЫЙ ПЛЯЖ",
					},
				},
				{
					id:  3,
					active:  false,
					title: "НАСЛАЖДЕНИЕ КРУГЛЫЙ ГОД",
					img: require("../assets/img/nick_alx__photo_Spa_treatments_girl_in_the_center_dark_colors_a_5f8a52fb-b647-42f6-b646-1ad8176ba14d 3.jpg"),
					subtitle: "ЗАКРЫТЫЙ И ПОДОГРЕВАЕМЫЙ УЛИЧНЫЙ БАССЕЙН",
					text: `
						Бассейн, комфортная температура воды в котором поддерживается круглый год.
						Теперь вы можете наслаждаться плаванием даже в прохладные дни!
						<br>
						Приятная атмосфера, комфортабельные шезлонги, а также возможность заказать
						любые напитки и закуски делает бассейн настоящей точкой притяжения гостей комплекса.
					`,
					tags: ['Подогреваемый бассейн под открытым небом', 'Напитки и закуски', 'Просторная парная', 'Караоке',],
					icon: {
						id:  3,
						src: require("../assets/img/svg/icon3.svg"),
						title: "ПОДОГРЕВАЕМЫЙ БАССЕЙН",
					},
				},
				{
					id:  4,
					active:  false,
					title: "ЗАБОТА О СЕБЕ",
					img: require("../assets/img/nick_alx__photo_Spa_treatments_girl_in_the_center_dark_colors_a_5f8a52fb-b647-42f6-b646-1ad8176ba14d 4.jpg"),
					subtitle: "SPA-ПРОЦЕДУРЫ И УХОД",
					text: `
						SPA-комплекс «Эвкалипт» идеально подходит для тех, кто хочет зарядиться энергией,
						избавиться от стресса и скрыться от городской суеты.
						<br>
						Широкий спектр услуг — от сауны и хаммама до массажей и комплексных
						косметологических программ — позволяет полностью погрузиться в мир расслабления и удовольствия.
					`,
					tags: ['Банный комплекс', 'Соляная пещера', 'Гидромассажные джакузи', 'Сауны', 'Косметологический кабинет', 'Оздоровительные и расслабляющие массажи', 'Хамамы', 'Лаундж зона', 'Грязевая купель', 'Открытые бассейны',],
					icon: {
						id:  4,
						src: require("../assets/img/svg/icon4.svg"),
						title: "SPA | УХОД",
					},
				},

			],
		}
	},
	mounted() {
		setTimeout(() => {
			if (this.$store.getters.screenWidth  <  575)  {
				if (this.$refs.mobile_services_gallery) {
					this.services_box_height = this.$refs.mobile_services_gallery.clientHeight + 'px'
				}
			} else {
				this.services_box_height = 'auto'
			}
		}, 1000)
	},
	computed:  {
		gallery_items_active() {
			return this.gallery_items.find(item => item.active)
		},

	},
	methods: {
		mobile_services_gallery_arrow_right_click_handle() {
			setTimeout(() => {this.services_box_height = this.$refs.mobile_services_gallery.clientHeight + 'px'}, 500)
			let active_idx = this.gallery_items.findIndex(item => item.active)
			let last_idx  = this.gallery_items.length - 1
			this.gallery_items_active.active = false
			if  (active_idx  ===  last_idx)   {
				this.gallery_items[0].active = true
			} else  {
				this.gallery_items[active_idx+1].active = true
			}
		},
		mobile_services_gallery_arrow_left_click_handle() {
			setTimeout(() => {this.services_box_height = this.$refs.mobile_services_gallery.clientHeight + 'px'}, 500)
			let active_idx = this.gallery_items.findIndex(item => item.active)
			let last_idx  = this.gallery_items.length - 1
			this.gallery_items_active.active = false
			if  (active_idx  ===  0) {
				this.gallery_items[last_idx].active = true
			} else  {
				this.gallery_items[active_idx-1].active = true
			}
		},
		gallery_items_click_handle(item_id) {
			let new_active_item= this.gallery_items.find(item => item.id === item_id)
			this.gallery_items_active.active = false
			new_active_item.active = true
			// for (let item of this.gallery_items)  {
			// 	item.active = item.id === item_id
			// }
		},
		content_text_size_toggle() {
			this.is_content_text_short = !this.is_content_text_short
		},
	}
}
</script>

<style scoped>

.fade-img-enter-active,
.fade-img-fade-leave-active {
	transition: opacity 0.2s ease-out;
	opacity: 1;
}

.fade-img-enter,
.fade-img-leave-to { /* .fade-leave-active below version 2.1.8 */
	opacity: 0;
}



.fade-text-enter-active, .fade-text-leave-active {
	transition: opacity 0.2s ease-out;
	opacity: 1;
	/*height: 100%;*/
}

.fade-text-enter,
.fade-text-leave-to { /* .fade-leave-active below version 2.1.8 */
	opacity: 0;
	/*height: 0;*/
}

.desktop_services_gallery {
	width: 100%;
	position: relative;
}

.mobile_services_gallery {
	width: 100%;
	position: relative;
}
.mobile_services_gallery_content {
	height: 35vh;
	width: 100%;
	overflow: hidden;
	position: relative;
}
.mobile_services_gallery_box_img {
	width: 100%;
	height: 100%;
	position: relative;
	overflow: hidden;
	z-index: 1;
}
.mobile_services_gallery_img {
	object-fit: cover;
	height: 100%;
}
.services_content_box,
.mobile_services_content_box {
	width: 100%;
	position:relative;
	z-index: 4;
}

.mobile_services_content {
	position: relative;
	top: -5em
}

.mobile_services_content_icon {
	width: 100%;
	height: 10%;
}
.mobile_services_content_icon img {
    position: relative;
    padding-bottom: 1em;
	height: 10%;
	width: auto;
	margin: 0 auto;
    display: flex;
}

.services_content {
	width: 70%;
	max-width: 900px;
	margin: 0 auto;
	display: flex;
	position: relative;

	/*min-height: 50vh;*/
}
.services_content_title,
.mobile_services_content_title {
	position: relative;
	font-size: 1.5em;
	font-weight: 200;
	color: white;
	letter-spacing: 0.2em;

}

.services_content_subtitle,
.mobile_services_content_subtitle {
	font-size: 0.85em;
	letter-spacing: 0.1em;
	padding-bottom: 0.5em;
}
.mobile_services_content_title {
	font-size: 1.8em;
	color: white;
	line-height: 1.3em;
}
.mobile_services_content_title,
.mobile_services_content_subtitle {
	position: relative;
	margin: 0 auto;
    font-weight: 200;
    width: 100%;
	padding: 0 2em;
    text-align: center;
    padding-bottom: 1em;
}

.services_content_text,
.mobile_services_content_text {
	font-weight: 200;
	font-size: 0.9em;
}
.mobile_tags_box {
	padding: 0em 1em;
}
.mobile_services_content_text {
	padding: 1.4em;
	font-size: 0.9em;
}
.mobile_services_gallery_arrow_left {left: -8px;}
.mobile_services_gallery_arrow_right {right: -8px;}

.mobile_services_gallery_arrow_left,
.mobile_services_gallery_arrow_right {
	position: absolute;
	top: 20px;
	/*height: 100%;*/
	/*transform: translateY(-50%);*/
	z-index: 20;
	width: 10%;
	/*height: 100vh;*/
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;

}
.mobile_services_gallery_arrow_left svg,
.mobile_services_gallery_arrow_right svg {
	height: 1.2em;
	width: auto;
}

.tags_box {
	width: 50%;
	padding: 0.5em;
}
.mobile_tags_box {

}

.mobile_tags_box > button, .mobile_tags_box > button:active {
	text-align: left;
	padding: 0.1em 0.5em;
	font-size: 0.7em;
	border-radius: 0.8em;
	background-color: #A6CBD3 !important;
	box-shadow: none;
	border: 1px solid #A6CBD3 !important;
	margin: 0.3em;
	color: #161616;
}
.tags_box > button, .tags_box > button:active {
	text-align: left;
	padding: 0.3em 0.7em;
	font-size: 0.7em;
	border-radius: 0.8em;
	background-color: transparent !important;
	box-shadow: none;
	border: 1px solid #A6CBD3 !important;
	margin: 0.5em;
	color: #A6CBD3;
}

.services_box {
	position: relative;
	color: #A6CBD3;
	background-color: #161616;
	overflow: hidden;
	width: 100%;
}


.desktop_services_gallery img {
	object-fit: cover;
	width: 100%;
	/*padding-bottom: 3em;*/
}
.services_gallery_menu img  {
	padding-bottom: 3em;
	/*width: 80px;*/
	/*height: 100px;*/
	object-fit: contain;
}

.services_gallery_menu {
	position: absolute;
	left: 0;
	right: 0;
	bottom: -1em;
	z-index: 10;
	font-size: 0.5em;
    display: flex;
    justify-content: center;
    align-items: baseline;
    width: 80%;
    margin: 0 auto;
    text-align: center;
}
.services_gallery_menu_item {
	margin: 3em;
}

.services_gallery_menu_item {
	transition: all 0.4s ease-out;
    display: flex;
    flex-flow: row wrap;
    flex-direction: column;
    align-items: center;
	opacity: 0.5;
}
.services_gallery_menu_item:hover, .services_gallery_menu_item.active:hover {
	cursor: pointer;
	opacity: 1;
}
.services_gallery_menu_item.active  {
	opacity: 0.9;
}

.services_services_gallery_content {
}

.services_gallery_menu_item_img_box {
	position: relative;
}

.services_gallery_menu_item_img_animation {
	transition: height 0.5s ease-in-out, opacity 0.1s ease-in-out;
	position: absolute;
	top: -15px;
	bottom: 0;
	right: 0;
	left: 0;
	border-radius: 1000px;
	margin: auto;
	height: 35px;
	width: 35px;
	transform: rotate(45deg);
	background-color: rgba(95, 167, 164, 0.50);
	opacity: 0;
}
.services_gallery_menu_item.active services_gallery_menu_item_img_animation,
.services_gallery_menu_item.active .services_gallery_menu_item_img_animation,
.services_gallery_menu_item:hover .services_gallery_menu_item_img_animation {
	height: 70px;
	opacity: 1;
}
/*.services_gallery_menu_item.active:hover .services_gallery_menu_item_img_animation*/
/* {*/
/*	height: 35px;*/
/*	opacity: 0.8;*/
/*}*/

.mobile_content_text_btn_box {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1em;
	position: absolute;
	bottom: 0;
}

.mobile_content_text_btn:hover,
.mobile_content_text_btn:active,
.mobile_content_text_btn:focus,
.mobile_content_text_btn {
	color: #A6CBD3;
	background-color: transparent !important;
	border: none !important;
	border-radius: 0 !important;
	box-shadow: none !important;
	padding: 0 !important;
    font-size: 1.2em !important;
	border-bottom: 1px solid  #A6CBD3 !important;
	z-index: 10;
}

.mobile_content_text_btn {
	position: absolute;
	bottom: 0;
}

@media (max-width: 575px) {
	.services_box {
		transition: height 0.5s ease-out;
		width: 100%;
		position: relative;
		min-height: 100vh;
		color: #A6CBD3;
		background-color: #161616;
		overflow: hidden;
		/*height: auto;*/
	}

	.services_box.short {
		transition: height 0.5s ease-out;
		height: 100vh !important;
		width: 100%;
		position: relative;
		color: #A6CBD3;
		background-color: #161616;
		overflow: hidden;
	}
}
</style>